import PropTypes from 'prop-types';
import React from 'react';

import { ConfigType } from '../types';
import GameContext from './context';

export const GameProvider = ({ children, config }) => (
  <GameContext.Provider value={{ ...config }}>{children}</GameContext.Provider>
);

GameProvider.propTypes = {
  children: PropTypes.node.isRequired,
  config: ConfigType.isRequired,
};

GameProvider.displayName = 'GameProvider';

export default GameProvider;
